(() => {
  if (window.mehdiGalleryVideoPositionLoaded) return;
  window.mehdiGalleryVideoPositionLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const originalPositions = new WeakMap();
  let updateFrame = null;

  function rememberOriginalPosition(content) {
    if (originalPositions.has(content)) return;

    const marker = document.createComment('mehdi-gallery-content-position');

    if (content.parentNode) {
      content.parentNode.insertBefore(marker, content);
      originalPositions.set(content, marker);
    }
  }

  function restoreOriginalPosition(content) {
    const marker = originalPositions.get(content);

    if (!marker || !marker.parentNode) return;

    if (content.previousSibling !== marker) {
      marker.parentNode.insertBefore(content, marker.nextSibling);
    }
  }

  function moveGalleryContent() {
    document
      .querySelectorAll('.product-gallery-under-content')
      .forEach((content) => {
        rememberOriginalPosition(content);

        const productInformation = content.closest(
          '[data-testid="product-information"]'
        );

        if (!productInformation) return;

        if (mobileQuery.matches) {
          const shareBlock = productInformation.querySelector(
            '.mehdi-product-actions'
          );

          if (!shareBlock) return;

          if (shareBlock.nextElementSibling !== content) {
            shareBlock.insertAdjacentElement('afterend', content);
          }
        } else {
          restoreOriginalPosition(content);
        }
      });
  }

  function scheduleUpdate() {
    if (updateFrame) {
      window.cancelAnimationFrame(updateFrame);
    }

    updateFrame = window.requestAnimationFrame(() => {
      updateFrame = null;
      moveGalleryContent();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
  } else {
    scheduleUpdate();
  }

  window.addEventListener('load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', scheduleUpdate);
  } else {
    mobileQuery.addListener(scheduleUpdate);
  }

  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('shopify:section:reorder', scheduleUpdate);
  document.addEventListener('shopify:block:select', scheduleUpdate);

  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();